<template>
  <div id="menber_address" class="menber_control menber_nav padding-30">
    <TabBar :list="tabList" :active="tabActive" @active="active"/>
    <div class="b_cont">
      <div :class="'order_list order_' + [tabActive === 0 ? tabActive + ' active_bg' : active]">
        <ul>
          <li class="m-b-15" v-for="(item, index) in list" :class="{'move_bg': item.showBg, 'active_bg': item.isDefault === '1' || item.edit}" v-if="index < page * pageSize && index+1 > (page-1) * pageSize"
          @mouseout="item.showBg = false" @mouseover="item.showBg = true">
            <div class="order_h padding_t_b_20">
              <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="order_title">
                  <span v-if="!item.isEdit">{{item.name}}</span>
                  <input v-if="item.isEdit" name="name" type="text" v-model="item.name" :placeholder="item.name">
                </div>
                <div class="order_cont">
                  <span class="cont1 col-xs-12 col-sm-6 m-b-5" data-text="1"><strong>手机：</strong>
                    <i v-if="!item.isEdit">{{item.mobile}}</i>
                    <input v-if="item.isEdit" name="mobile" type="text" v-model="item.mobile" :placeholder="item.mobile">
                  </span>
                  <span class="cont1 col-xs-12 col-sm-6 m-b-5" data-text="1"><strong>电话：</strong>
                    <i v-if="!item.isEdit">{{item.phone}}</i>
                    <input v-if="item.isEdit" name="mobile" type="text" v-model="item.phone" :placeholder="item.phone">
                  </span>
                  <span class="cont3 col-xs-12 col-sm-6 m-b-5" data-text="3"><strong>邮编：</strong>
                    <i v-if="!item.isEdit">{{item.zipCode}}</i>
                    <input v-if="item.isEdit" name="zipCode" type="text" v-model="item.zipCode" :placeholder="item.zipCode">
                  </span>
                  <span class="cont4 col-xs-12 col-sm-6 m-b-5" data-text="4"><strong>地址：</strong>
                    <i v-if="!item.isEdit">{{item.address}}</i>
                    <input v-if="item.isEdit" name="address" type="text" v-model="item.address" :placeholder="item.address">
                  </span>
                  <span class="cont5 col-xs-12 col-sm-6 m-b-5" v-if="item.isEdit">
                    <strong>地区：</strong>
                    <Area :one="item.areaPath.split(',')[0]" :two="item.areaPath.split(',')[0]+','+item.areaPath.split(',')[1]" :three="item.areaPath"
                    @change="changeArea($event, item)"/>
                  </span>
                </div>
              </div>
            </div>
            <div class="order_b padding_t_b_20">
              <div class="col-xs-12 col-sm-12 col-md-6 m-b-15 order_btn">
                <a href="javascript:;" class="order_del" @click="del(item.receiverId)">删除信息</a>
                <a href="javascript:;" class="order_detail" :class="{'active_fix': item.isEdit}" :style="{'background-color': item.isEdit? $store.state.color : ''}"  @click="edit(item)">
                  <span v-if="!item.isEdit">修改信息</span><span v-if="item.isEdit">确认修改</span>
                </a>
                <a href="javascript:;" class="order_default" :class="{'order_pay': item.isDefault === '1'}" @click="setDefault(item, $event)">
                  <span v-if="item.isDefault === '1'">已设默认</span><span v-if="item.isDefault !== '1'">设为默认</span>
                </a>
              </div>
            </div>
          </li>
        </ul>
        <div v-if="list.length>0">
          <Pagination :page="page" :pageSize="pageSize" :count="list.length" @change-page="changePage"/>
        </div>
      </div>
      <div :class="'order_list order_' + [tabActive === 1 ? tabActive + ' active_bg' : active]">
        <ul>
          <li class="m-b-15" :class="{'move_bg':showBg}" @mouseout="showBg = false" @mouseover="showBg = true">
            <div class="order_h padding_t_b_20">
              <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="order_cont">
                  <span class="cont1 col-xs-12 col-sm-6 m-b-5"><strong>姓名：</strong><i><input name="text1" type="text" v-model="detail.name" placeholder="姓名"></i></span>
                  <span class="cont2 col-xs-12 col-sm-6 m-b-5"><strong>手机：</strong><i><input name="text2" type="text" v-model="detail.mobile" placeholder="手机号码"></i></span>
                  <span class="cont3 col-xs-12 col-sm-6 m-b-5"><strong>电话：</strong><i><input name="text3" type="text" v-model="detail.phone" placeholder="电话号码"></i></span>
                  <span class="cont4 col-xs-12 col-sm-6 m-b-5"><strong>邮编：</strong><i><input name="text4" type="text" v-model="detail.zipCode" placeholder="如:312000"></i></span>
                  <span class="cont5 col-xs-12 col-sm-6 m-b-5"><strong>地址：</strong><i><input name="text5" type="text" v-model="detail.address" placeholder="详细地址"></i></span>
                  <span class="cont6 col-xs-12 col-sm-6 m-b-5">
                    <strong>地区：</strong>
                    <Area :one="detail.areaPath.split(',')[0]" :two="detail.areaPath.split(',')[0]+','+detail.areaPath.split(',')[1]" :three="detail.areaPath" @change="changeDetailArea($event)"/>
                  </span>
                </div>
              </div>
            </div>
            <div class="order_b padding_t_b_20">
              <div class="col-xs-12 col-sm-12 col-md-4 m-b-15 order_btn">
                <a href="javascript:;" class="order_add" @click="add">保存添加</a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import TabBar from '@/components/TabBar'
import Pagination from '@/components/Pagination'
import Area from '@/components/Area'
export default {
  components: {
    TabBar,
    Pagination,
    Area
  },
  data () {
    return {
      tabList: [
        {name: '已有收货地址', number: 0},
        {name: '添加收货地址'}
      ],
      tabActive: 0,
      // 数据
      list: [],
      page: 1,
      pageSize: 2,
      // 边框
      showBg: false,
      isEdit: false,
      detail: {
        areaPath: '402881882ba8753a012ba8da48e000b0,402881882ba8753a012ba8da7d2f00b1'
      }
    }
  },
  created () {
    this.get()
  },
  methods: {
    active (index) {
      this.tabActive = index
    },
    get () {
      var ctx = this
      window.$.ajax({
        url: '/rest/api/shop/receiver/list',
        success (res) {
          if (res.success) {
            var data = res.attributes.data
            data.forEach((item, index, arr) => {
              item.showBg = false
              item.isEdit = false
            })
            ctx.list = data
            ctx.tabList[0].number = data.length
          } else {
            // window.alert(res.msg)
          }
        }
      })
    },
    changePage (page) {
      this.page = page
    },
    // 删除信息
    del (id) {
      var ctx = this
      window.confirm('确认是否删除?', '', function (isConfirm) {
        if (isConfirm) {
          alert('删除成功！', '', function () {}, {type: 'success'})
          ctx.list.forEach((item, index, arr) => {
            if (item.receiverId === id) {
              arr.splice(index, 1)
            }
          })
          window.$.ajax({
            url: '/rest/api/shop/receiver/detail/' + id,
            method: 'post',
            data: {
              _method: 'DELETE'
            },
            success: function (res) {
              if (res.success) {
                ctx.tabList[0].number = ctx.list.length
                console.log('delete address success')
              }
            }
          })
        } else {
          alert('取消删除！', '', function () {}, {type: 'success'})
        }
      }, {confirmButtonText: '确认', cancelButtonText: '取消!', width: 300})
    },
    // 修改收货地址
    edit (item) {
      if (this.isEdit) {
        if (item.isEdit) {
          window.alert('保存修改成功', '', function () {}, {type: 'success'})
          item.isEdit = false
          this.isEdit = false
          window.$.ajax({
            type: 'post',
            url: '/rest/api/shop/receiver/detail/' + item.receiverId,
            data: {
              model: JSON.stringify(item),
              _method: 'put'
            },
            success (res) {
              if (res.success) {
                console.log('edit address success')
              } else {
                alert(res.msg)
              }
            }
          })
        } else {
          // 先确认当前是否有数据未保存
          window.alert('当前有数据未保存，请先确认保存修改内容？')
        }
      } else {
        item.isEdit = true
        this.isEdit = true
      }
    },
    // 地址设为默认
    setDefault (item, e) {
      var ctx = this
      if (item.isDefault === '1') { return '' }
      window.confirm('确认设为默认?', '', function (isConfirm) {
        if (isConfirm) {
          alert('保存成功！', '', function () {}, {type: 'success'})
          item.isDefault = '1'
          ctx.list.forEach((row, index, arr) => {
            if (row.receiverId !== item.receiverId) {
              row.isDefault = '0'
            }
          })
          window.$.ajax({
            type: 'post',
            url: 'http://www.jihui88.com/rest/api/shop/receiver/detail/' + item.receiverId,
            data: {
              model: JSON.stringify(item),
              _method: 'put'
            },
            success (res) {
              if (res.success) {
                console.log('edit isDefault success')
              } else {
                alert(res.msg)
              }
            }
          })
          // ajax
        } else {
          alert('保存失败！', '', function () {}, {type: 'error'})
        }
      }, {confirmButtonText: '确认', cancelButtonText: '取消!', width: 300})
    },
    // 添加收货地址
    add () {
      var ctx = this
      if (!this.detail.name) { return alert('请输入收货人的姓名！') }
      if (!this.detail.mobile) { return alert('请输入手机号码！') }
      if (!(/^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/.test(this.detail.mobile))) { return alert('请输入正确手机号码！') }
      if (!this.detail.address) { return alert('请输入详细地址！') }
      if (!this.detail.areaPath) { return alert('请选择所在地区！') }
      window.$.ajax({
        type: 'post',
        url: 'http://www.jihui88.com/rest/api/shop/receiver/detail',
        data: {
          model: JSON.stringify(this.detail),
          _method: 'post'
        },
        success (res) {
          if (res.success) {
            var data = res.attributes.data
            data.showBg = false
            data.isEdit = false
            ctx.list.push(data)
            ctx.tabList[0].number = ctx.list.length
            window.alert('添加成功！', '', function () {}, {type: 'success'})
          } else {
            alert(res.msg)
          }
        }
      })
    },
    changeArea (data, item) {
      item.areaPath = data
    },
    changeDetailArea (data) {
      this.detail.areaPath = data
    }
  }
}
</script>

<style lang="css">
/*地址列表*/
#menber_address .order_list .order_title {
	color:#999;
	transition:all 0.3s ease 0s;
	-moz-transition:all 0.3s ease 0s;
	-webkit-transition:all 0.3s ease 0s;
	-o-transition:all 0.3s ease 0s;
}
#menber_address .order_list li.active_bg .order_title {
	color:#f96868;
}
#menber_address .order_list li.active_bg {
	border-color:#f96868;
}
#menber_address .order_list li.active_bg .order_h {
	border-bottom-color:#f96868;
}
#menber_address .order_list .order_detail.active_fix {
	background: #62a8ea;
    border-color: #62a8ea;
    color: #fff;
}
#menber_address .order_list .order_title input {
	background:none;
	border:1px solid #eee;
	margin:0;
	padding:0;
	display:inline-block;
	width:40%;
	font-size:14px;
	line-height:2;
	outline:0;
	text-indent:3%;
}
#menber_address .order_list .order_cont>span>i {
	font-style:normal;
}
#menber_address .order_list .order_cont>span input {
	background:none;
	border:1px solid #eee;
	margin:0;
	padding:0;
	display:inline-block;
	width:80%;
	font-size:14px;
	line-height:2;
	outline:0;
	text-indent:3%;
}
#menber_address .order_list .order_cont>span strong {
	float:left;
}
#menber_address .order_list .order_cont>span select {
	background:none;
	border:1px solid #eee;
	padding:0;
	font-size:14px;
	height:30px;
}
#menber_address .order_0 .order_b .order_btn a {
	width:26%;
}
#menber_address .order_b .order_add {
	float:right;
	margin:0;
}
#menber_address .order_b .order_btn {
	float:right;
}
</style>



// WEBPACK FOOTER //
// src/pages/Address.vue